import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  /**
     * constructor
     * @param http
     */
  constructor(private http: HttpClient) {
  }

  /**
   * get country list
   * @returns 
   */
  getCountryList(): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Countries`;
    return this.http.get(url);

  }
  
  /**
   * get country odata list
   * @returns 
   */
  getCountryODataList(): Observable<any> {
    const url = `${environment.guestApiUrl}/odata/Countries`;
    return this.http.get(url);

  }
  
  /**
   * get region list
   * @param countryId 
   * @returns 
   */
  getRegionList(countryId: string): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Countries/county/${countryId}`;
    return this.http.get(url);
  }

  /**
   * get city List
   * @param regionId 
   * @returns 
   */
  getCityList(regionId: string): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Countries/county/city/${regionId}`;
    return this.http.get(url);
  }

  /**
   * get designation List
   * @returns 
   */
  getDesignationList(): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Lookup/type?type=DesignationType&isEnum=true`;
    return this.http.get(url);
  }

  /**
   * get industry type list
   * @returns industry lookup rows
   */
  getIndustryTypeList(): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Lookup/type?type=IndustryType&isEnum=false`;
    return this.http.get(url);
  }

  /**
   * get product List
   * @returns 
   */
  getProductList(): Observable<any> {
    const url = `${environment.guestApiUrl}/api/Lookup/type?type=Product&isEnum=true`;
    return this.http.get(url);
  }

  /**
   * get service List
   * @returns 
   */
  getServiceList(): Observable<any> {
    const url = `${environment.guestApiUrl}/api/AutomotiveServices/lookup/serviceType/Application`;
    return this.http.get(url);
  }

  /**
   * self registration
   * @param formData 
   * @returns 
   */
  selfRegistration(formData): Observable<any> {
    const url = `${environment.guestApiUrl}/api/SelfRegistration`;
    return this.http.post(url, formData)
  }

  /**
   * Submit free trial self registration with auto approval.
   * @param payload registration body
   * @param options optional request headers (e.g. initial email-only step)
   * @returns registration response
   */
  autoApprovalSelfRegistration(
    payload: Record<string, any>,
    options?: { initialStep?: boolean }
  ): Observable<any> {
    const url = `${environment.guestApiUrl}/api/SelfRegistration/auto-approval`;
    let headers = new HttpHeaders();
    if (options?.initialStep) {
      headers = headers.append('initialStep', 'true');
    }
    return this.http.post(url, payload, { headers });
  }

  /**
   * validate self registration otp
   * @param payload
   * @returns
   */
  validateSelfRegistrationOtp(payload: Record<string, any>): Observable<any> {
    const url = `${environment.guestApiUrl}/api/SelfRegistration/validate-otp`;
    return this.http.post(url, payload);
  }

  /**
   * get external token
   * @returns 
   */
  getToken(): any {
    const url = `${environment.guestApiUrl}/oauth2/v2.0/token`;
    const headers = new HttpHeaders().append('Ocp-Apim-Subscription-Key', environment.guestSubscriptionKey);
    return this.http.post(url, null, { headers: headers });
  }

}
